import React, { useEffect, useState } from "react";
import "../../assets/scss/setting-table.scss";
import Summary from "../small-components/summary";
import Notes from "../small-components/notes";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import EstimateCalculator from "./EstimateCalculator";
import fire from "../../config/firebase";
import Moment from "moment";
import { useHistory, withRouter } from "react-router-dom";
import { Paper } from "@material-ui/core";
import SaveTemplate from "../small-components/SaveTemplate/SaveTemplate";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  tab: {
    "& .MuiBox-root": {
      padding: "0px",
    },
  },
  indicator: {
    backgroundColor: "#e70a89",
    ripple: {
      color: "transparent",
      backgroundColor: "transparent",
    },
  },
  buttonit: {
    // padding: '5px 15px 6px',
    borderRadius: "5px",
    backgroundColor: "#084d4f",
    color: "#fff",
    "&:hover": {
      backgroundColor: "transparent",
      color: "#084d4f",
    },
  },
  plusIcon: {
    padding: 0,
  },
  addTask: {
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "1.36",
    color: "#3066be",
  },
}));

function TaskBased(props) {
  const { updateCnt = 0 } = props;
  const [template, setTemplate] = React.useState({});
  const [showSaveTemplate, showTemplate] = useState(false);
  const history = useHistory();

  const pathArr = props.location.pathname.split('/');
  const key = pathArr[pathArr.length - 1];
  const dataType = props.match.path.includes("estimates")
    ? "estimates"
    : "templates";
  const isTemplate = dataType === "templates";
  const classes = useStyles();
  const [value, setValue] = React.useState("scope");

  const tabHandler = (type) => {
    setValue(type);
  };
  const refreshData = () => {
    const dataType = props.match.path.includes("estimates")
      ? "estimates"
      : "templates";
    const pathArr = props.location.pathname.split('/');
    const key = pathArr[pathArr.length - 1];
    const ref = fire.database().ref(dataType + "/" + key);

    ref.once("value").then(
      (snapshot) => {
        const template = snapshot.val();
        ref.off("value");
        setTemplate(template);
      },
      (error) => {
        console.log("Error: " + error.code);
      }
    );
  }
  useEffect(() => {
    refreshData();
  }, [updateCnt]);

  const createEstimate = () => {
    showTemplate(true)
    // const { key } = props.match.params;
    const copy = { ...template };
    copy.id = null;
    copy.date = Moment(new Date()).format("DD/MM/YYYY");
    copy.timestamp = Math.floor(Date.now() / 1000);
    copy.modified = Moment(new Date()).format("h:mm a MMMM DD, YYYY");
    const estimateRef = fire.database().ref("estimates");
    estimateRef.push(copy);
    //These lines are removing estimates from templates page .
    //const refOriginal = fire.database().ref("templates/" + key);
    //refOriginal.remove();
    //history.push(`/estimates`);
  };

  const [isEmpty, setIsEmpty] = useState(true);

  useEffect(() => {
    let temp = true;
    if (template) {
      const { phases = [] } = template;
      for (const phase of phases) {
        const { tasks = [] } = phase;
        for (const task of tasks) {
          const { resources = [] } = task;
          if (resources.length > 0) {
            temp = false;
          }
        }
      }
    }
    setIsEmpty(temp);
  }, [template]);

  return (
    <div
      className="summary-details template-modify"
      style={{
        borderColor: isTemplate ? "#2ab7ca" : "#fff",
        borderWidth: isTemplate ? "3px" : "3px 0 0 0",
        borderStyle: "solid",
      }}
      key={key}
    >
      {showSaveTemplate ?
        <Paper className="MuiDrawer-paper MuiDrawer-paperAnchorRight">
          <SaveTemplate />
        </Paper>
        : null}

      {isTemplate ? (
        <div className="violator-bar">
          <Typography variant="h5" component="h5">
            You are currently modifying a template
          </Typography>
          <div className="btn-wrap">
            <Button variant="contained" type="button" onClick={createEstimate}>
              Create Estimate
            </Button>
          </div>
        </div>
      ) : null}
      <div className="container">
        <ul className="tabs-wrap">
          <li className={value === "scope" ? "active" : ""}>
            <Button onClick={() => tabHandler("scope")}>
              <p>Scope</p>
            </Button>
          </li>
          <li
            className={
              value === "summary" ? "active" : isEmpty ? "notActive" : ""
            }
          >
            {isEmpty ? (
              <p>Summary</p>
            ) : (
              <Button disabled={isEmpty} onClick={() => tabHandler("summary")}>
                <p>Summary</p>
              </Button>
            )}
          </li>
          <li className={value === "notes" ? "active" : ""}>
            <Button onClick={() => tabHandler("notes")}>
              <p>Notes</p>
            </Button>
          </li>
        </ul>
        <div className="content-wrapper">
          <div className={`scope-wrap ${value === "scope" ? "active" : ""}`}>
            <EstimateCalculator
              classes={classes}
              key={key}
              updateCnt={updateCnt}
              update={props.update}
            />
          </div>
          <div
            className={`summary-wrap ${value === "summary" ? "active" : ""}`}
          >
            {value === "summary" ? (
              <Summary
                dataType={dataType}
                dataKey={key}
                key={"summary" + key}
              />
            ) : null}
          </div>
          <div className={`notes-wrap ${value === "notes" ? "active" : ""}`}>
            <Notes />
          </div>
        </div>
      </div>
    </div>
  );
}
export default withRouter(TaskBased);
